import { Color, PaletteColor } from "@mui/material";

export const c1Light = "#839cb4";
export const c1Dark = "#5b667c";
export const c2Light = "#69b966";
export const c2Dark = "#3d7a3d";
export const c3Light = "#b160c1";
export const c3Dark = "#6c3e7c";

export const chart1 = {
  light: c1Light,
  dark: c1Dark,
};
export const chart2 = {
  light: c2Light,
  dark: c2Dark,
};
export const chart3 = {
  light: c3Light,
  dark: c3Dark,
};

export const patternLink = "#456aef";
export const goldStar = "#eab308";

export const patternPeri = {
  50: "#eef3fe",
  100: "#d6e0fc",
  200: "#baccfb",
  300: "#9eb7f9",
  400: "#8aa7f7",
  500: "#7598f6",
  600: "#6d90f5",
  700: "#6285f3",
  800: "#587bf2",
  900: "#456aef",
  A100: "#ffffff",
  A200: "#ffffff",
  A400: "#dde4ff",
  A700: "#c3cfff",
};

export const grey: Color = {
  50: "#f3f6fa",
  100: "#ced4e0",
  200: "#a5acc0",
  300: "#7e89a7",
  400: "#556486",
  500: "#33436c",
  600: "#232e4b",
  700: "#1d2741",
  800: "#172038",
  900: "#0e1428",
  A100: "#7B96FF",
  A200: "#486DFF",
  A400: "#1544FF",
  A700: "#0032FB",
};

export const NewGreys = {
  background0: "#F3F6FA",
  background1: "#EEF2F8",
  muiInputGrayBorder: "rgba(0, 0, 0, 0.23)",
};

export const Amber = {
  500: "#f59e0b",
};

export const primary: Color = {
  50: "#EEF2FF",
  100: "#D4E0FE",
  200: "#B7CBFE",
  300: "#9AB6FE",
  400: "#85A6FD",
  500: "#6F96FD",
  600: "#678EFD",
  700: "#5C83FC",
  800: "#5279FC",
  900: "#4068FC",
  A100: "#FFFFFF",
  A200: "#FFFFFF",
  A400: "#E5EAFF",
  A700: "#CBD5FF",
};

export const patternSecondary: Color = {
  50: "#E8FCF8",
  100: "#C7F6EE",
  200: "#A1F1E2",
  300: "#7BEBD6",
  400: "#5FE6CE",
  500: "#43E2C5",
  600: "#3DDFBF",
  700: "#34DAB8",
  800: "#2CD6B0",
  900: "#1ECFA3",
  A100: "#FFFFFF",
  A200: "#D2FFF3",
  A400: "#9FFFE6",
  A700: "#85FFDF",
};

export const tertiary: PaletteColor = {
  light: "#FFC2A9",
  main: "#FF5528",
  dark: "#FF5528",
  contrastText: "#000",
};

export const success: PaletteColor = {
  light: "#1bbe2b",
  main: "#1bbe2b",
  dark: "#1bbe2b",
  contrastText: "#fff",
};

export const error: PaletteColor = {
  light: "#FE4242",
  main: "#FE4242",
  dark: "#FE4242",
  contrastText: "#000",
};

export const info: PaletteColor = {
  light: "#46C0F4",
  main: "#46C0F4",
  dark: "#46C0F4",
  contrastText: "#000",
};

export const warning: PaletteColor = {
  light: "#ffff69",
  main: "#FFDE30",
  dark: "#c8ad00",
  contrastText: "#000",
};
